import Vue from 'vue'
import App from './App.vue'
import store from './store'

import './config/gtm.js'
import './config/yandex.js'

import lodash from 'lodash'
import vmodal from 'vue-js-modal'
import VeeValidate from 'vee-validate';
import VueTheMask from 'vue-the-mask'
import vueTopprogress from 'vue-top-progress'
import VueAwesomeSwiper from 'vue-awesome-swiper'
import VueMeta from 'vue-meta'
import LoadScript from 'vue-plugin-load-script';
import $ from 'jquery'

// import firebaseConfig from './config/firebase'
// import firebase from 'firebase'

window.$ = window.jQuery = require('jquery');
window.axios = require('axios');
var VueScrollTo = require('vue-scrollto');
var VueCookie = require('vue-cookie');
var ionRangeSlider = require('ion-rangeslider');

// js libs
import 'bootstrap/dist/js/bootstrap.min.js'
import './plugins/sharer.js'
import './plugins/pinchzoomer/hammer.js'
import './plugins/pinchzoomer/TweenMax.js'
import './plugins/pinchzoomer/jquery.pinchzoomer.js'
import 'selectric/public/jquery.selectric.min.js'
import './plugins/svgIcon.js'
import '@/assets/icons'
// css libs
import 'swiper/dist/css/swiper.css'
import 'selectric/public/themes/plus/selectric.css'
import 'ion-rangeslider/css/ion.rangeSlider.min.css'
// import 'v-calendar/lib/v-calendar.min.css';
// import 'vue-select/dist/vue-select.css';

window.body = $('body');
window.url = 'https://old-cms.sales.bazis.kz/cms/';
window.newsUrl = 'https://news.bazis.kz/cms/';
window.newsVweb = 'https://kohota.v-web.kz/cms/';
window.CRMurl = 'https://bazis-online.kz/crmc';
window.CRMurlTest = 'https://testcrm.bazis.kz/crmc';
window.host = window.location.host.split('.')[0]; // PRODUCTION VAR
// window.host = 'orion-iii'; // dev var
window.JsonUrl = 'wp-json/acf/v3/';
window.GlobalLang = localStorage.getItem('languageShablon');

if (window.host == 'kohota') {
  if (window.GlobalLang == null || window.GlobalLang == '') {
    window.GlobalLang = 'uz/';
    setDataLang(window.GlobalLang);
  } else if (window.GlobalLang == 'ru/') {
    window.GlobalLang = '';
    setDataLang(window.GlobalLang);
  } else if (window.GlobalLang == 'kz/') {
    window.GlobalLang = 'uz/';
    setDataLang(window.GlobalLang);
  } else {
    setDataLang(window.GlobalLang);
  }
} else {
  // console.log(window.GlobalLang)
  if (window.GlobalLang == null || window.GlobalLang == '') {
    window.GlobalLang = '';
    setDataLang(window.GlobalLang);
  } else if (window.GlobalLang == 'ru/') {
    window.GlobalLang = '';
    setDataLang(window.GlobalLang);
  } else if (window.GlobalLang == 'uz/') {
    window.GlobalLang = 'kz/';
    setDataLang(window.GlobalLang);
  } else if (window.GlobalLang == 'kz/') {
    window.GlobalLang = 'kz/';
    setDataLang(window.GlobalLang);
  } else {
    setDataLang(window.GlobalLang);
  }
}



function setDataLang(lang) {
  if (lang = '') {
    document.querySelector('body').dataset.language = window.GlobalLang;
  } else {
    document.querySelector('body').dataset.language = window.GlobalLang.replace(/\/$/, "");
  }
}

const configVeeValidate = {
  aria: true,
  classNames: {},
  classes: false,
  delay: 0,
  errorBagName: 'errors', // change if property conflicts
  events: 'input|blur',
  fieldsBagName: 'fields',
  i18n: null, // the vue-i18n plugin instance
  i18nRootKey: 'validations', // the nested key under which the validation messages will be located
  inject: true,
  locale: 'ru',
  validity: false
};

const configScrollTo = {
  container: "body",
  duration: 1200,
  easing: "ease-in-out",
  force: true,
  cancelable: true,
  onStart: false,
  onDone: false,
  onCancel: false,
  x: false,
  y: true
};

// firebase.initializeApp(firebaseConfig);

Vue.use(VueAwesomeSwiper);
Vue.use(VueTheMask);
Vue.use(vmodal);
Vue.use(vueTopprogress);
Vue.use(LoadScript);
Vue.use(VueCookie);
Vue.use(VeeValidate, configVeeValidate);
Vue.use(VueScrollTo, configScrollTo);
Vue.use(VueMeta);

new Vue({
  // router,
  render: h => h(App),
  store,
  mounted: () => document.dispatchEvent(new Event("x-app-rendered"))
}).$mount('#app')
